import React, { useLayoutEffect, useState, useRef } from "react";

function FrameText({ text, transform, textColor, textFont, textSize }) {
  const [cordinateY, setCordinateY] = useState(0);
  const [fontSizeFrameText, setFontSizeFrameText] = useState(50);
  const textRef = useRef(null);

  useLayoutEffect(() => {
    if (textRef.current) {
      const textWidth = textRef.current.getComputedTextLength();
      const frameWidth = 150;

      let newFontSize = fontSizeFrameText;
      if (textWidth > frameWidth && newFontSize > 10) {
        const ratio = frameWidth / textWidth;
        newFontSize = Math.max(10, Math.floor(fontSizeFrameText * ratio));
      } else if (textWidth < frameWidth && newFontSize < 50) {
        const ratio = frameWidth / textWidth;
        newFontSize = Math.min(50, Math.ceil(fontSizeFrameText * ratio));
      }

      if (textSize && textSize !== -1) {
        setFontSizeFrameText(textSize);
        newFontSize = textSize;
      } else if (newFontSize !== fontSizeFrameText) {
        setFontSizeFrameText(newFontSize);
      }

      if (newFontSize >= 50) {
        setCordinateY(0);
      } else if (newFontSize >= 40) {
        setCordinateY(-4);
      } else if (newFontSize >= 30) {
        setCordinateY(-7);
      } else {
        setCordinateY(-11);
      }
    }
  }, [text, textSize]);

  const newId = Math.floor(Math.random() * 1000 + 1);

  return (
    <g transform={transform}>
      <style>
        {`
          .small${newId}{
            fill:${textColor};
            font-size:${fontSizeFrameText}px;
            font-family: ${textFont}, sans-serif;
          }
        `}
      </style>
      <text
        ref={textRef}
        x="0"
        y={cordinateY}
        textAnchor="middle"
        className={`small${newId}`}
      >
        {text}
      </text>
    </g>
  );
}

export default FrameText;
